import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

const getSeasonalCardTheme = (month) => {
  if (month === 9) return "halloween";
  if (month === 11) return "christmas";
  return "classic";
};

export const ThemeProvider = ({ children }) => {
  // Initialize theme state with the value from localStorage or a default value
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme === "dark" || savedTheme === "retro" ? "dark" : "light";
  });
  const [month, setMonth] = useState(() => new Date().getMonth());
  const [seasonalCardsEnabled, setSeasonalCardsEnabled] = useState(
    () => localStorage.getItem("myBetsSeasonalCards") !== "false"
  );

  const toggleTheme = (newTheme) => {
    const normalizedTheme = newTheme === "dark" ? "dark" : "light";
    setTheme(normalizedTheme);
    localStorage.setItem("theme", normalizedTheme);
  };

  const toggleSeasonalCards = (enabled) => {
    setSeasonalCardsEnabled(enabled);
    localStorage.setItem("myBetsSeasonalCards", String(enabled));
  };

  // Ensure the theme is loaded from localStorage when the component mounts
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    const normalizedTheme = savedTheme === "dark" || savedTheme === "retro" ? "dark" : "light";
    setTheme(normalizedTheme);
    localStorage.setItem("theme", normalizedTheme);
  }, []);

  useEffect(() => {
    const updateMonth = () => setMonth(new Date().getMonth());
    const timer = window.setInterval(updateMonth, 60 * 60 * 1000);
    return () => window.clearInterval(timer);
  }, []);

  const cardThemePreview = new URLSearchParams(window.location.search).get("cardTheme");
  const activeCardTheme = ["classic", "halloween", "christmas"].includes(cardThemePreview)
    ? cardThemePreview
    : getSeasonalCardTheme(month);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, activeCardTheme, seasonalCardsEnabled, toggleSeasonalCards }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);